import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import TeamsMembersModal from 'modules/teams/components/MembersModal'
import type { ITeam } from 'modules/teams/store/models/Team'

interface Props {
  team: ITeam
  readonly: boolean
  contractVersions: ContractVersions
}

const BlankState = ({ team, readonly, contractVersions }: Props) => {
  const [open, setOpen] = React.useState(false)

  const handleOpenModal = () => {
    setOpen(true)
    track(trackingEvents.teams.addTeamDetailsLeaderStart)
  }

  return (
    <Box
      alignItems="center"
      justifyContent="center"
      minHeight="s200"
      border={{
        all: {
          style: 'solid',
          width: 's1',
          color: 'grey400',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
      padding="s40"
      minWidth="s360"
      gap="s24"
    >
      <Text.Normal weight="medium" size="200">
        {i18n.t('teams.leaders.blank_description')}
      </Text.Normal>
      {!readonly && (
        <Button disabled={readonly} onClick={handleOpenModal} type="secondary">
          {i18n.t('teams.leaders.blank')}
        </Button>
      )}
      {open && (
        <TeamsMembersModal
          selectedGroup="leaders"
          team={team}
          onClose={() => setOpen(false)}
          contractVersions={contractVersions}
        />
      )}
    </Box>
  )
}

export default observer(BlankState)
